import Swal from "sweetalert2"
import { ADDBUSINESSPROFILE, GETBUSSINESSPROFILE, UPDATEBUSINESSPROFILE } from "../../utils/api"
import axios from "../../utils/axios"
import { swalAlertPopProps } from "../../utils/commonUtils"

export const getGusinessProfile=async(userDetail,callback)=>{
    await axios.get(GETBUSSINESSPROFILE+"/"+userDetail?.myBusinessId).then((res)=>{
        callback(res)
    }).catch((err)=>{console.log("error ",err)})
}



export const UpdateProfile=async(payload,callback)=>{
    await axios.post(UPDATEBUSINESSPROFILE,payload).then((res)=>{
        callback(res) 
        Swal.fire({
            text:"Successfully Update" ,
            icon: "success",
            ...swalAlertPopProps ,
          });
    }).then((err)=>{
        console.log("err",err)
    })
}

export const addProfile=async(payload,callback)=>{
    await axios.post(ADDBUSINESSPROFILE,payload).then((res)=>{
        callback(res) 
        Swal.fire({
            text:"Successfully Add" ,
            icon: "success",
            ...swalAlertPopProps ,
          });
    }).then((err)=>{
        console.log("err",err)
    })
}



